module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-05.b8f91a5d.png";